const vehicleReport = {
  title: 'Relatório de Viagem do Veículo',
  description: 'Fornece informações estatísticas sobre a atividade de motoristas individuais.',
  table: {
    headers: {
      id: 'Identificação',
      driver: 'Motorista',
      supplier: 'Fornecedor',
      vehicle: 'Veículo',
      zones: 'Zonas',
      locations: 'Localizações',
      profiles: 'Perfis',
      attributes: 'Atributos',
      trips: 'Viagens',
      driverShifts: 'TURNO',
      start: 'Início',
      departureTime: 'SCHEDULED DEPARTURE',
      end: 'Fim',
      hours: 'Horas',
      booking: 'Reserva',
      tripDuration: 'Duração da Viagem',
      tripDistance: 'Distância da Viagem',
      distanceToPickUp: 'Distância até a Coleta',
      totalDistance: 'Distância total',
      loadedDistance: 'Distância com Passageiro',
      earningPerHour: 'Ganho por Hora',
      amount: 'Quantidade',
      cost: 'Custo',
    },
    driver: 'Motorista',
    Amount: 'Quantidade',
    unassignedTrips: 'Não Atribuído',
    yes: 'SIM',
    no: 'NÃO',
  },

  filter: {
    export: 'Exportar',
    driver: 'Motorista',
    supplier: 'Fornecedor',
    car: 'Veículo',
    zones: 'Zonas',
    locations: 'Localizações',
    airportLocations: 'Localizações de Aeroporto',
    profiles: 'Perfis',
    attributes: 'Atributos',
    submit: 'Filtrar',
    clear: 'Limpar filtro', 
    driverShifts: {
      title: 'Turnos de Motoristas',
      options: {
        withShifts: 'Com Turno',
        withoutShifts: 'Sem Turno'
      }
    },
    validation: {
      startDateRequired: 'A data de início é obrigatória',
      endDateRequired: 'A data de término é obrigatória',
    },
  },

  vehicleSummary: {
    total: 'Veículos',
    totalTrips: 'Viagens',
    totalReservation: 'Reservas',
    loadedDistance: 'Distância carregada',
    totalCost: 'Custo Total',
  },

  form: {
    dateEnd: 'Data de fim',
    dateStart: 'Data de início',
  },
  export: 'Relatório de Veículo',
};

export default vehicleReport;
